package com.pincer.core.rules

import com.pincer.core.model.tree.Candidate

class AndRule(rules: Set<Rule>): CompoundRule(rules) {
    override fun score(candidate: Candidate): Float = scoreEach(candidate).first()
}
